import utils from '../utils.js';

var isAxiosError;
var hasRequiredIsAxiosError;

function requireIsAxiosError () {
	if (hasRequiredIsAxiosError) return isAxiosError;
	hasRequiredIsAxiosError = 1;

	var utils$1 = utils;

	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	isAxiosError = function isAxiosError(payload) {
	  return utils$1.isObject(payload) && (payload.isAxiosError === true);
	};
	return isAxiosError;
}

export { requireIsAxiosError as __require };
//# sourceMappingURL=isAxiosError.js.map
